import { clientOnlyLazy } from '#/utils/clientOnlyLazy';

export const ClientOnlyLazySearchJobsRefinements = clientOnlyLazy(() =>
  import('./SearchJobsRefinements').then((m) => ({
    default: m.SearchJobsRefinements,
  })),
);
